import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import { InsProductVariantDetails_productVariant } from "@saleor/instagram/types/InsProductVariantDetails";
import { InstagramDetails_instagram_instagramtag } from "@saleor/instagram/types/InstagramDetails";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import React, { Dispatch, SetStateAction, useState } from "react";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
export interface InstagramTagUpdateDialogFormData {
  id: string;
  pcx: number;
  pcy: number;
  mbx: number;
  mby: number;
  productvariant: string;
}

export interface Coordinate {
  x: number;
  y: number;
}
export interface ProductVariantFormData {
  sku: string;
  name: string;
  skuName: string;
  urlSlug: string;
  price: number;
  oldPrice: number;
}

export interface InstagramTagUpdateDialogProps {
  open: boolean;
  tagProductVariant: InsProductVariantDetails_productVariant;
  onClose: () => void;
  instagramImage: string;
  confirmButtonState?: ConfirmButtonTransitionState;
  instagramTag: InstagramDetails_instagram_instagramtag;
  onSubmit: (data: InstagramTagUpdateDialogFormData) => void;
  productVariant: number;
  setProductVariant: Dispatch<SetStateAction<number>>;
}

const useStyles = makeStyles(
  {
    pcfdiv: {
      width: 402,
      height: 402,
      display: "inline-block",
      position: "relative"
    },
    pcmc: {
      width: 402,
      height: 402,
      display: "block",
      position: "relative",
      zIndex: 2,
      borderLeft: "32.16px solid rgba(0,0,0,.5)",
      borderRight: "32.16px solid rgba(0,0,0,.5)",
      borderTop: "54.94px solid rgba(0,0,0,.5)",
      borderBottom: "26.8px solid rgba(0,0,0,.5)",
      padding: 0,
      margin: 0
    },
    pcimage: {
      width: 402,
      height: 402,
      objectFit: "cover",
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 1
    },
    Mobilefdiv: {
      width: 402,
      lineHeight: 0,
      display: "inline-block",
      position: "relative",
      marginLeft: 50,
      height: "fit-content"
    },
    Mobilemc: {
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      display: "block",
      position: "absolute",
      borderLeft: "38.592px solid rgba(0,0,0,.5)",
      borderRight: "38.592px solid rgba(0,0,0,.5)",
      borderTop: "64.32px solid rgba(0,0,0,.5)",
      borderBottom: "40.736px solid rgba(0,0,0,.5)",
      zIndex: 2
    },
    Mobileimage: {
      width: 402
      // height: 402,
      // objectFit: "cover",
      // display: "block",
      // zIndex: 1,
      // position: "absolute",
      // top: 0,
      // left: 0,
      // bottom: 0,
      // right: 0
    },
    TagTriangle: {
      width: 0,
      height: 0,
      borderWidth: 6,
      borderStyle: "solid",
      bottom: "-12px",
      position: "absolute",
      borderColor: "#000 transparent transparent transparent",
      color: "#ffff"
    },
    PcTag: {
      width: 107.2,
      height: 37.52,
      border: 0,
      borderRadius: 4,
      backgroundColor: "rgb(0,0,0,0.8)",
      position: "absolute",
      zIndex: 998,
      marginTop: -43.52
    },
    MobileTag: {
      width: 171.52,
      height: 42.88,
      borderRadius: 4,
      border: 0,
      backgroundColor: "rgb(0,0,0,0.8)",
      position: "absolute",
      zIndex: 998,
      marginTop: -48.88,
      lineHeight: "20px",
      marginBottom: "10px"
      // overflow:"hidden",
    },
    textP: {
      fontSize: 7,
      color: "#FF7733",
      zIndex: 999,
      marginLeft: 10,
      marginTop: 1,
      marginBottom: 2,
      display: "inline-block"
    },
    textOP: {
      textDecoration: "line-through",
      fontSize: 6,
      color: "#BBBBBB",
      zIndex: 999,
      marginLeft: 5,
      marginTop: 1,
      marginBottom: 2,
      display: "inline-block"
    },
    textV: {
      fontSize: 7,
      color: "#FFFFFF",
      zIndex: 999,
      marginLeft: 10,
      marginTop: 2,
      marginBottom: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "80%"
    },
    MtextP: {
      fontSize: 13,
      color: "#FF7733",
      zIndex: 999,
      marginLeft: 20,
      marginTop: 1,
      marginBottom: 5
    },
    MtextV: {
      fontSize: 13,
      color: "#FFFFFF",
      zIndex: 999,
      marginLeft: 20,
      marginTop: 2,
      marginBottom: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "80%"
    }
  },
  { name: "InstagramTagUpdateDialog" }
);

const InstagramTagUpdateDialog: React.FC<InstagramTagUpdateDialogProps> = ({
  open,
  onClose,
  instagramTag,
  instagramImage,
  confirmButtonState,
  onSubmit,
  productVariant,
  setProductVariant,
  tagProductVariant
}) => {
  const intl = useIntl();

  const classes = useStyles();

  const productVariantFromData: ProductVariantFormData = {
    sku: maybe(() => tagProductVariant?.variantId.toString(), ""),
    name: maybe(
      () =>
        tagProductVariant?.product?.name +
        " " +
        tagProductVariant?.attributes[0].values[0].value,
      ""
    ),
    skuName: maybe(() => tagProductVariant?.skuName, ""),
    urlSlug: maybe(() => tagProductVariant?.urlSlug, ""),
    price: maybe(() => tagProductVariant?.price.amount, 0),
    oldPrice: maybe(
      () => tagProductVariant?.pricing.priceUndiscounted.gross.amount,
      0
    )
  };

  const [pcCoordinate, setPcCoordinate] = useState<Coordinate>({
    x: instagramTag?.pcx,
    y: instagramTag?.pcy
  });
  const [mbCoordinate, setMbCoordinate] = useState<Coordinate>({
    x: instagramTag?.mbx,
    y: instagramTag?.mby
  });

  useEffect(() => {
    // eslint-disable-next-line no-console
    // console.log(
    //   "pcCoordinatepcCoordinatepcCoordinatepcCoordinatepcCoordinate",
    //   pcCoordinate
    // );
    setPcCoordinate({
      x: instagramTag?.pcx,
      y: instagramTag?.pcy
    });
    setMbCoordinate({
      x: instagramTag?.mbx,
      y: instagramTag?.mby
    });
  }, [instagramTag]);
  // setMbCoordinate(
  //  { x: instagramTag?.mbx,
  //   y: instagramTag?.mby}
  // )
  // setPcCoordinate(
  //  { x: instagramTag?.pcx,
  //   y: instagramTag?.pcy}
  // )

  const initialForm: InstagramTagUpdateDialogFormData = {
    id: maybe(() => instagramTag.id, ""),
    pcx: maybe(() => pcCoordinate.x, instagramTag?.pcx),
    pcy: maybe(() => pcCoordinate.y, instagramTag?.pcy),
    mbx: maybe(() => mbCoordinate.x, instagramTag?.mbx),
    mby: maybe(() => mbCoordinate.y, instagramTag?.mby),
    productvariant: maybe(() => productVariant.toString(), "")
  };

  function setPcXY(x, y) {
    const pcDivTop = document
      .getElementsByClassName(classes.pcmc)[0]
      ?.getBoundingClientRect().top;
    const pcDivLeft = document
      .getElementsByClassName(classes.pcmc)[0]
      ?.getBoundingClientRect().left;
    const pcx = Math.floor(((x - pcDivLeft) / 402) * 100 * 100) / 100;
    const pcy = Math.floor(((y - pcDivTop) / 402) * 100 * 100) / 100;
    if (
      x < 402 - 32.16 + pcDivLeft + 2 &&
      x > 32.16 + pcDivLeft - 2 &&
      y < 402 - 26.8 + pcDivTop + 2 &&
      y > 54.94 + pcDivTop - 2
    ) {
      setPcCoordinate({
        x: pcx,
        y: pcy
      });
    }
  }

  function setMbXY(x, y) {
    const mbDivTop = document
      .getElementsByClassName(classes.Mobilemc)[0]
      ?.getBoundingClientRect().top;
    const mbDivLeft = document
      .getElementsByClassName(classes.Mobilemc)[0]
      ?.getBoundingClientRect().left;

    const divHeight = document.getElementById("Mobilefdiv").clientHeight;

    const mbx = Math.floor(((x - mbDivLeft) / 402) * 100 * 100) / 100;
    const mby = Math.floor(((y - mbDivTop) / divHeight) * 100 * 100) / 100;
    if (
      (x < 402 - 38.592 + mbDivLeft + 2 &&
        x > 38.592 + mbDivLeft - 2 &&
        y < divHeight - 40.736 + mbDivTop + 2 &&
        y > 64.32 + mbDivTop - 2) ||
      !!!mbDivLeft
    ) {
      setMbCoordinate({
        x: mbx,
        y: mby
      });
    }
  }
  return (
    <>
      <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
        <DialogTitle>
          <FormattedMessage
            defaultMessage="Update Tag"
            description="Update instagram instagramTag"
          />
        </DialogTitle>
        <Form initial={initialForm} onSubmit={onSubmit}>
          {({ change, data, submit }) => (
            <>
              <DialogContent style={{ paddingTop: 0, paddingBottom: 10 }}>
                <div style={{ padding: 28, marginTop: 0, display: "flex" }}>
                  <div className={classes.pcfdiv}>
                    <div
                      className={classes.pcmc}
                      onClick={event => setPcXY(event.clientX, event.clientY)}
                    />
                    {instagramTag ? (
                      data.pcx < 30 ? (
                        <div
                          className={classes.PcTag}
                          style={{
                            top: `${data?.pcy}%`,
                            left: `${data?.pcx}%`,
                            marginLeft: -21.008
                          }}
                        >
                          <p className={classes.textV}>
                            {productVariantFromData?.name}
                          </p>
                          <p className={classes.textP}>
                            US ${productVariantFromData?.price}
                          </p>
                          {productVariantFromData?.oldPrice !==
                          productVariantFromData?.price ? (
                            <p className={classes.textOP}>
                              US ${productVariantFromData?.oldPrice}
                            </p>
                          ) : (
                            ""
                          )}
                          <div
                            className={classes.TagTriangle}
                            style={{ left: 15.008 }}
                          />
                        </div>
                      ) : data.pcx < 70 ? (
                        <div
                          className={classes.PcTag}
                          style={{
                            top: `${data?.pcy}%`,
                            left: `${data?.pcx}%`,
                            marginLeft: -50.7
                          }}
                        >
                          <p className={classes.textV}>
                            {productVariantFromData?.name}
                          </p>
                          <p className={classes.textP}>
                            US ${productVariantFromData?.price}
                          </p>
                          {productVariantFromData?.oldPrice !==
                          productVariantFromData?.price ? (
                            <p className={classes.textOP}>
                              US ${productVariantFromData?.oldPrice}
                            </p>
                          ) : (
                            ""
                          )}
                          <div
                            className={classes.TagTriangle}
                            style={{ left: 43.5 }}
                          />
                        </div>
                      ) : (
                        <div
                          className={classes.PcTag}
                          style={{
                            top: `${data?.pcy}%`,
                            left: `${data?.pcx}%`,
                            marginLeft: -86.192
                          }}
                        >
                          <p className={classes.textV}>
                            {productVariantFromData?.name}
                          </p>
                          <p className={classes.textP}>
                            US ${productVariantFromData?.price}
                          </p>
                          {productVariantFromData?.oldPrice !==
                          productVariantFromData?.price ? (
                            <p className={classes.textOP}>
                              US ${productVariantFromData?.oldPrice}
                            </p>
                          ) : (
                            ""
                          )}
                          <div
                            className={classes.TagTriangle}
                            style={{ right: 15.008 }}
                          />
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <img className={classes.pcimage} src={instagramImage}></img>
                  </div>

                  <div className={classes.Mobilefdiv} id="Mobilefdiv">
                    <div
                      className={classes.Mobilemc}
                      onClick={event => setMbXY(event.clientX, event.clientY)}
                    />
                    {instagramTag ? (
                      data.mbx < 30 ? (
                        <div
                          className={classes.MobileTag}
                          style={{
                            top: `${data?.mby}%`,
                            left: `${data?.mbx}%`,
                            marginLeft: -26.368
                          }}
                        >
                          <p className={classes.MtextV}>
                            {productVariantFromData?.name}
                          </p>
                          <p className={classes.MtextP}>
                            US ${productVariantFromData?.price}
                          </p>
                          {productVariantFromData?.oldPrice !==
                          productVariantFromData?.price ? (
                            <p className={classes.textOP}>
                              US ${productVariantFromData?.oldPrice}
                            </p>
                          ) : (
                            ""
                          )}
                          <div
                            className={classes.TagTriangle}
                            style={{ left: 20.368 }}
                          />
                        </div>
                      ) : data.mbx < 70 ? (
                        <div
                          className={classes.MobileTag}
                          style={{
                            top: `${data?.mby}%`,
                            left: `${data?.mbx}%`,
                            marginLeft: -85.76
                          }}
                        >
                          <p className={classes.MtextV}>
                            {productVariantFromData?.name}
                          </p>
                          <p className={classes.MtextP}>
                            US ${productVariantFromData?.price}
                          </p>
                          {productVariantFromData?.oldPrice !==
                          productVariantFromData?.price ? (
                            <p className={classes.textOP}>
                              US ${productVariantFromData?.oldPrice}
                            </p>
                          ) : (
                            ""
                          )}
                          <div
                            className={classes.TagTriangle}
                            style={{ left: 79.76 }}
                          />
                        </div>
                      ) : (
                        <div
                          className={classes.MobileTag}
                          style={{
                            top: `${data?.mby}%`,
                            left: `${data?.mbx}%`,
                            marginLeft: -145.152
                          }}
                        >
                          <p className={classes.MtextV}>
                            {productVariantFromData?.name}
                          </p>
                          <p className={classes.MtextP}>
                            US ${productVariantFromData?.price}
                          </p>
                          {productVariantFromData?.oldPrice !==
                          productVariantFromData?.price ? (
                            <p className={classes.textOP}>
                              US ${productVariantFromData?.oldPrice}
                            </p>
                          ) : (
                            ""
                          )}
                          <div
                            className={classes.TagTriangle}
                            style={{ right: 20.368 }}
                          />
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <img
                      className={classes.Mobileimage}
                      src={instagramImage}
                    ></img>
                  </div>
                </div>
                <TextField
                  name={"pcx" as keyof InstagramTagUpdateDialogFormData}
                  label={intl.formatMessage({
                    defaultMessage: "PC-X",
                    description: "pcx"
                  })}
                  value={data.pcx}
                  onChange={change}
                  style={{
                    marginLeft: 86.25,
                    width: 125
                  }}
                />
                <TextField
                  name={"pcy" as keyof InstagramTagUpdateDialogFormData}
                  label={intl.formatMessage({
                    defaultMessage: "PC-Y",
                    description: "pcy"
                  })}
                  value={data.pcy}
                  style={{
                    marginLeft: 20,
                    width: 125
                  }}
                  onChange={change}
                />
                <TextField
                  name={"mbx" as keyof InstagramTagUpdateDialogFormData}
                  label={intl.formatMessage({
                    defaultMessage: "MB-X",
                    description: "mbx"
                  })}
                  value={data.mbx}
                  onChange={change}
                  style={{
                    marginLeft: 182.5,
                    width: 125
                  }}
                />
                <TextField
                  name={"mby" as keyof InstagramTagUpdateDialogFormData}
                  label={intl.formatMessage({
                    defaultMessage: "MB-Y",
                    description: "mby"
                  })}
                  value={data.mby}
                  style={{
                    marginLeft: 20,
                    width: 125
                  }}
                  onChange={change}
                />
                <div style={{ margin: 10 }} />
                <TextField
                  disabled
                  label={intl.formatMessage({
                    defaultMessage: "SKU Name",
                    description: "skuname"
                  })}
                  value={
                    productVariantFromData?.skuName
                      ? productVariantFromData?.skuName
                      : productVariantFromData?.name
                  }
                  style={{
                    marginLeft: 86.25,
                    width: 270
                  }}
                />
                <TextField
                  disabled
                  label={intl.formatMessage({
                    defaultMessage: "Price",
                    description: "sku url"
                  })}
                  value={productVariantFromData?.price + ""}
                  style={{
                    marginLeft: 182.5,
                    width: 125
                  }}
                />
                <TextField
                  disabled
                  label={intl.formatMessage({
                    defaultMessage: "Old Price",
                    description: "sku url"
                  })}
                  value={productVariantFromData?.oldPrice + ""}
                  style={{
                    marginLeft: 20,
                    width: 125
                  }}
                />
                <div style={{ margin: 5 }} />
                <TextField
                  disabled
                  label={intl.formatMessage({
                    defaultMessage: "SKU URL",
                    description: "sku url"
                  })}
                  value={productVariantFromData?.urlSlug + ""}
                  style={{
                    marginLeft: 86.25,
                    width: 270
                  }}
                />
                <TextField
                  label={intl.formatMessage({
                    defaultMessage: "SKU Code",
                    description: "sku"
                  })}
                  value={productVariant + ""}
                  style={{
                    marginLeft: 182.5,
                    width: 270
                  }}
                  onChange={event => {
                    setProductVariant(Number(event.target.value));
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose}>
                  <FormattedMessage {...buttonMessages.back} />
                </Button>
                <ConfirmButton
                  disabled={!!!tagProductVariant}
                  transitionState={confirmButtonState}
                  color="primary"
                  variant="contained"
                  onClick={submit}
                >
                  <FormattedMessage {...buttonMessages.save} />
                </ConfirmButton>
              </DialogActions>
            </>
          )}
        </Form>
      </Dialog>
    </>
  );
};

export default InstagramTagUpdateDialog;
